<div class="text-danger" *ngIf="errorMessage !== null" id="err-{{ elementId }}" role="alert">{{ errorMessage }}</div>